module.exports = {
      id: "like-color-vector-usage",
      viewBox: "0 0 25 23",
      url: "img/" + "sprite.svg#like-color-vector-usage",
      toString: function () {
        return this.url;
      }
    }